<template>
    <b-container>
        <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
        <b-card>
            <tab-nav :tabs="true" id="myTab-1">
                <tab-nav-items :active="true" id="home-tab" ariaControls="home" role="tab" :ariaSelected="true" title="Datos de contacto" />
                <tab-nav-items :active="false" id="reportes-tab" ariaControls="reportes" role="tab" :ariaSelected="false" title="Reportes" />
                <tab-nav-items :active="false" id="calendario-tab" ariaControls="calendario" role="tab" :ariaSelected="false" title="Calendario" />
                <tab-nav-items :active="false" id="monitor-tab" ariaControls="monitor" role="tab" :ariaSelected="false" title="Monitor" />
            </tab-nav>
            <tab-content id="myTabContent">
                <tab-content-item :active="true" id="home" aria-labelled-by="home-tab">
                    <dl class="row">
                        <dt class="col-sm-3">Nombre</dt>
                        <dd class="col-sm-9">{{userData.firstName}}</dd>
                        <dt class="col-sm-3">Apellido</dt>
                        <dd class="col-sm-9">{{userData.lastName}}</dd>
                        <dt class="col-sm-3">Correo Electrónico</dt>
                        <dd class="col-sm-9">{{userData.email}}</dd>
                        <dt class="col-sm-3">Genero</dt>
                        <dd class="col-sm-9">{{userData.gender}}</dd>
                        <dt class="col-sm-3">Cumpleaños</dt>
                        <dd class="col-sm-9" v-if="userData.birthday">{{moment(new Date((userData.birthday._seconds) * 1000), "YYYY-MM-DD").format("YYYY-MM-DD")}}</dd>
                    </dl>

                    <b-row class="mt-60">
                        <b-col lg="6">
                            <b-row>
                                <b-col lg="6" md="6">
                                    <iq-card>
                                        <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
                                        <template v-slot:body>
                                            <div class="text-center"><span>Rutinas Creadas</span></div>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="value-box">
                                                    <h2 class="mb-0"><Counter :key="countRoutinesKey" :value="countRoutines.created" /></h2>
                                                </div>
                                                <div class="iq-iconbox iq-bg-info">
                                                    <i class="ri-arrow-up-line" />
                                                </div>
                                            </div>
                                        </template>
                                    </iq-card>
                                </b-col>
                                <b-col lg="6" md="6">
                                    <iq-card>
                                        <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
                                        <template v-slot:body>
                                            <div class="text-center"><span>Rutinas Asigandas</span></div>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="value-box">
                                                    <h2 class="mb-0"><Counter :key="countRoutinesKey" :value="countRoutines.assigned" /></h2>
                                                </div>
                                                <div class="iq-iconbox iq-bg-info">
                                                    <i class="ri-arrow-up-line" />
                                                </div>
                                            </div>
                                        </template>
                                    </iq-card>
                                </b-col>
                                <b-col lg="6" md="6">
                                    <iq-card>
                                        <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
                                        <template v-slot:body>
                                            <div class="text-center"><span>Rutinas en Ejecución</span></div>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="value-box">
                                                    <h2 class="mb-0"><Counter :key="countRoutinesKey" :value="countRoutines.working" /></h2>
                                                </div>
                                                <div class="iq-iconbox iq-bg-info">
                                                    <i class="ri-arrow-up-line" />
                                                </div>
                                            </div>
                                        </template>
                                    </iq-card>
                                </b-col>
                                <b-col lg="6" md="6">
                                    <iq-card>
                                        <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
                                        <template v-slot:body>
                                            <div class="text-center"><span>Rutinas Terminadas</span></div>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="value-box">
                                                    <h2 class="mb-0"><Counter :key="countRoutinesKey" :value="countRoutines.done" /></h2>
                                                </div>
                                                <div class="iq-iconbox iq-bg-info">
                                                    <i class="ri-arrow-up-line" />
                                                </div>
                                            </div>
                                        </template>
                                    </iq-card>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col lg="6">
                            <h6>Progreso de Peso</h6>
                            <VueApexCharts type="line" :key="weightKey" :options="weightOptions" :series="weightSeries"></VueApexCharts>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12">
                        </b-col>
                    </b-row>
                </tab-content-item>
                <tab-content-item :active="false" id="reportes" aria-labelled-by="reportes-tab">
                    <!-- dropdowns -->
                    <b-row>
                        <b-col>
                            <b-form-group label="Tipo de Reporte">
                                <v-select :closeOnSelect="true" v-model="report_type" :options="report_types"></v-select>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Estado">
                                <v-select :closeOnSelect="true" v-model="prepost_type" :options="prepost_types"></v-select>
                            </b-form-group>
                        </b-col>
                        <b-col v-if="prepost_type == 'pre-entrenamiento'">
                            <b-form-group :label="`Variable ${report_type === 'Comparativo' ? '(Seleccionar mas de una)' : ''}`">
                                <v-select :multiple="report_type == 'Comparativo' ? true : false" :closeOnSelect="true" v-model="training_type" :options="training_types"></v-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-button type="submit" variant="primary" @click="generateReport">Generar Reporte</b-button>
                            <!-- <b-button v-b-modal.pre-entrenamiento variant="primary" class="mr-1">Extra large modal</b-button> -->
                        </b-col>
                    </b-row>
                    <b-row v-if="isHasGeneratedReport">
                        <b-col lg="12" class="pt-4">Filtrar por:</b-col>
                        <b-col lg="12" class="pt-2">
                            <div class="btn-group" role="group" aria-label="Basic outlined example">
                                <button type="button" class="btn btn-outline-primary" :class="{'active': year}" @click="selectTab(1)">Año</button>
                                <button type="button" class="btn btn-outline-primary" :class="{'active': semester}" @click="selectTab(2)">Semestre</button>
                                <button type="button" class="btn btn-outline-primary" :class="{'active': month}" @click="selectTab(3)">Mes</button>
                            </div>
                        </b-col>
                        <b-col lg="12" class="pt-2 pb-5" >
                            <b-row >
                                <b-col lg="6" v-if=" year || semester || month">
                                    <b-form-group label="Año">
                                        <v-select :closeOnSelect="true" v-model="yearSelected" :options="yearList"></v-select>
                                    </b-form-group>
                                </b-col>
                                <b-col v-if="semester">
                                    <b-form-group label="Semestre" >
                                        <v-select :closeOnSelect="true" v-model="semesterSelected" :options="semesterList"></v-select>
                                    </b-form-group>
                                </b-col>
                                <b-col v-if="month">
                                    <b-form-group label="Mes">
                                        <v-select :closeOnSelect="true" v-model="monthSelected" :options="monthList"></v-select>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="2" class="pt-3 mt-1" v-if=" year || semester || month">
                                    <b-button type="submit" variant="primary" @click="refreshData(itemOptionsSelected)">Refrescar</b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <!-- graficas de pre-entrenamiento -->
                    <b-row class="pre-entrenamiento" v-if="pre_workout_report">
                        <b-col lg="12">
                            <div v-if="promedio !== null" class="pre-entrenamiento-promedio">
                                <p>Promedio: <span>{{parseInt(promedio)}}</span></p>
                            </div>
                        </b-col>
                        <b-col lg="12">
                            <VueApexCharts type="line" :options="options" :series="series"></VueApexCharts>
                        </b-col>
                    </b-row>
                    <!-- graficas de post entrenamiento -->
                    <b-row class="post-entrenamiento" v-if="post_workout_report">
                            <b-col lg="6" :key="countChargesKey + 'u'">
                                <h4>Carga</h4>
                                <VueApexCharts type="line" :options="loadOptions" :series="loadSeries" ></VueApexCharts>
                            </b-col>
                            <template v-for="(item, i) in series">
                                <b-col lg="6" :key="i">
                                    <h4>{{series[i].name}}</h4>
                                    <VueApexCharts type="line" :options="optionsPost[i]" :series="[...series[i]]"></VueApexCharts>
                                </b-col>
                            </template>
                    </b-row>
                    <!-- <b-modal ref="pre-entrenamiento" id="pre-entrenamiento" title="Reporte - Pre Workout" hide-footer>
                        <div v-if="promedio !== null" class="pre-entrenamiento-promedio">
                            <p>Promedio: <span>{{parseInt(promedio)}}</span></p>
                        </div>
                        <VueApexCharts type="line" :options="options" :series="series"></VueApexCharts>
                    </b-modal> -->
                    <!-- <b-modal ref="post-entrenamiento" id="post-entrenamiento" title="Reporte - Post Workout" hide-footer>
                    </b-modal> -->
                </tab-content-item>
                <tab-content-item :active="false" id="calendario" aria-labelled-by="calendario-tab">
                    <ClientCalendar :key="calendarKey" :calendarData='calendarData' />
                </tab-content-item>
                <tab-content-item :active="false" id="monitor" aria-labelled-by="monitor-tab">
                    <tab-nav :tabs="true" id="myTab-1">
                        <tab-nav-items :active="true" id="pruebas-tab" ariaControls="pruebas" role="tab" :ariaSelected="true" title="Pruebas" />
                        <tab-nav-items :active="false" id="competiciones-tab" ariaControls="competiciones" role="tab" :ariaSelected="false" title="Competiciones" />
                    </tab-nav>
                    <tab-content>
                        <tab-content-item :active="true" id="pruebas" aria-labelled-by="pruebas-tab">
                            <b-table
                                :items="tests"
                                :fields="testFields"
                                :sort-by.sync="testSortBy"
                                :sort-desc.sync="testSortDesc"
                                :key="testKey"
                                :per-page="testPerPage"
                                :current-page="testCurrentPage"
                                show-empty
                                empty-text="Sin datos para mostrar"
                                hover
                                head-variant="light">
                                <template #cell(show_details)="row">
                                    <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                                    {{ row.detailsShowing ? 'Ocultar' : 'Mostrar'}} Detalles
                                    </b-button>
                                </template>
                                <template #row-details="row">
                                    <b-card>
                                        <p><strong>Nombre:</strong> {{row.item.item.test_name}}</p>
                                        <p><strong>Resultado:</strong> {{row.item.item.text_result}}</p>
                                        <p><strong>Puntaje:</strong> {{row.item.item.number_result}}</p>
                                        <p><strong>Epoca:</strong> {{row.item.item.addition.epochs}}</p>
                                        <p><strong>Peso:</strong> {{row.item.item.addition.weight}}</p>
                                        <p><strong>Repeticiones:</strong> {{row.item.item.addition.repeat}}</p>
                                        <p><strong>Tipo de usuario:</strong> {{row.item.item.user_type}}</p>
                                        <p><strong>Fecha:</strong> {{moment(new Date((row.item.item.activity_date._seconds) * 1000), "YYYY-MM-DD").format("YYYY-MM-DD")}}</p>
                                    </b-card>
                                </template>
                            </b-table>
                            <div class="row">
                                <div class="col">
                                    <div
                                        class="dataTables_paginate paging_simple_numbers float-right"
                                    >
                                        <ul class="pagination pagination-rounded mb-0">
                                            <!-- pagination -->
                                            <b-pagination
                                                v-model="testCurrentPage"
                                                :total-rows="rows"
                                                :per-page="testPerPage"
                                            ></b-pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </tab-content-item>
                        <tab-content-item :active="false" id="competiciones" aria-labelled-by="competiciones-tab">
                            <b-table
                                :items="currentUserCompetitions"
                                :fields="competitionFields"
                                :sort-by.sync="competitionSortBy"
                                :sort-desc.sync="competitionSortDesc"
                                :key="competitionKey"
                                :per-page="competitionPerPage"
                                :current-page="competitionCurrentPage"
                                show-empty
                                empty-text="Sin datos para mostrar"
                                hover
                                head-variant="light">
                                <template #cell(show_details)="row">
                                    <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                                    {{ row.detailsShowing ? 'Ocultar' : 'Mostrar'}} Detalles
                                    </b-button>
                                </template>
                                <template #row-details="row">
                                    <b-card>
                                        <p><strong>Nombre:</strong> {{row.item.competition_info.name}}</p>
                                        <p><strong>Duración:</strong> {{row.item.competition_duration}}</p>
                                        <p><strong>Ciudad:</strong> {{row.item.competition_info.city}}</p>
                                        <p><strong>País:</strong> {{row.item.competition_info.country}}</p>
                                        <p><strong>Fecha:</strong> {{moment(new Date((row.item.competition_date._seconds) * 1000), "YYYY-MM-DD").format("YYYY-MM-DD")}}</p>
                                    </b-card>
                                </template>
                            </b-table>
                            <div class="row">
                                <div class="col">
                                    <div
                                        class="dataTables_paginate paging_simple_numbers float-right"
                                    >
                                        <ul class="pagination pagination-rounded mb-0">
                                            <!-- pagination -->
                                            <b-pagination
                                                v-model="competitionCurrentPage"
                                                :total-rows="competitionRows"
                                                :per-page="competitionPerPage"
                                            ></b-pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </tab-content-item>
                    </tab-content>
                </tab-content-item>
            </tab-content>
        </b-card>
    </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import axios from 'axios'
import Counter from '@/components/core/counter/Counter'
import ClientCalendar from './calendar'
import moment from 'moment'
import config from '@/config/constant'
import VueApexCharts from 'vue-apexcharts'
import _ from 'lodash';
import TabContentItem from '../../../components/core/tab/tab-content-item.vue'

const POST_WORKOUT = "post-workout"

export default {
    components: {
        Counter,
        ClientCalendar,
        VueApexCharts,
        TabContentItem
    },
    data() {
        return {
            loading: true,
            loadingWeight: true,
            calendarData: null,
            calendarKey: 1,
            userData: {
                firstName: '',
                lastName: ''
            },
            year: false,
            semester: false,
            month: false,
            yearList:[],
            monthList:[],
            semesterList:[
                1, 2
            ],
            yearSelected:'',
            monthSelected: '',
            semesterSelected: '',
            itemOptionsSelected: '',
            isHasGeneratedReport:false,
            pre_workout_report: false,
            post_workout_report: false,
            routines: null,
            assignedRoutines: null,
            countRoutines: {
                "created": 0,
                "assigned": 0,
                "working": 0,
                "done": 0,
                "unknow": 0
            },
            countRoutinesKey: 1,
            countChargesKey: 1,
            userCompetitions: null,
            competitions: null,
            tests: null,
            trainings: null,
            trainings_statistic: null,
            training_types: [],
            training_types_array: [],
            training_type: null,
            // Data reporte de carga
            loadTraining: [],
            report_types: ['Único', 'Comparativo'],
            report_type: null,
            prepost_type: null,
            prepost_types: ['pre-entrenamiento', 'post-entrenamiento'],
            promedio: null,
            weightOptions: {
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                xaxis: {
                    categories: []
                },
                noData: {
                    text: 'Aún no hay reportes de peso'
                }
            },
            options: {
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                xaxis: {
                    categories: []
                }
            },
            loadOptions: {
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                xaxis: {
                    categories: []
                }
            },
            loadSeries: [
                {
                    data: [],
                    name: 'Carga',
                    type: 'line'
                }
            ],
            optionsPost: [],
            series: [],
            weightSeries: [],
            weightKey: 1,
            testFields: [
                { key: 'item.activity_date', label: 'Fecha', sortByFormatted: true, sortable: true, formatter: value => {
                    return moment(new Date((value._seconds) * 1000), "YYYY-MM-DD").format("YYYY-MM-DD")
                }},
                { key: 'item.test_name', label: 'Nombre', sortable: true },
                { key: 'item.number_result', label: 'Resultado', sortable: true },
                {key: 'show_details', label: 'Mostrar detalles'}
            ],
            testCurrentPage: 0,
            testPerPage: 10,
            testSortBy: 'item.activity_date',
            testSortDesc: true,
            testKey: 1,
            currentUserCompetitions: [],
            competitionFields: [
                { key: 'competition_date', label: 'Fecha', sortByFormatted: true, sortable: true, formatter: value => {
                    return moment(new Date((value._seconds) * 1000), "YYYY-MM-DD").format("YYYY-MM-DD")
                }},
                { key: 'competition_name', label: 'Nombre', sortable: true },
                { key: 'competition_duration', label: 'Duración', sortable: true },
                {key: 'show_details', label: 'Mostrar detalles'}
            ],
            competitionSortBy: "competition_date",
            competitionSortDesc: true,
            competitionPerPage: 10,
            competitionCurrentPage: 0,
            competitionKey: 1
        }
    },
    computed: {
        rows () {
            return this.tests ? this.tests.length : 0
        },
        competitionRows() {
            return this.currentUserCompetitions ? this.currentUserCompetitions.length : 0
        }
    },
    methods: {
        moment: moment,
        getUserData (key) {
            axios.get(`${config.apiUrl}/users/bykey/${key}`)
            .then(r => {
                this.userData = r.data.data.item;
                this.loading = false;
                console.log('✅ Profile data', r.data.data);
            })
            .catch(e => {
                console.error('Error Getting Single User info', e)
                alert("Usuario no existe");
                history.back();
            })
        },
        getRoutines (id) {
            axios.get('https://us-central1-atpro-app.cloudfunctions.net/api/routines/all')
            .then(r => {
                this.routines = r.data.data;
                console.log('✅ Routines data', r.data.data);
                this.getAssignedRoutines(id);
            })
            .catch(e => {
                console.error('Error Getting Routines', e);
            })
        },
        getAssignedRoutines (key) {
            axios.get('https://us-central1-atpro-app.cloudfunctions.net/api/routines/routineAssigned/'+key)
            .then(r => {
                this.assignedRoutines = r.data.data;
                console.log('✅ Assigned Routines data', r.data.data)
                let routinesList = [];
                // console.log('Rutinas Base', this.routines);
                r.data.data.forEach(e => {
                    // console.log('Rutina', e.item, this.routines)
                    this.routines.filter(x => {
                        if(x.key == e.item.routine_id){
                            // console.log('✅ ✅ Rutina encontrada');
                            routinesList.push(x.item);
                        }
                    })
                    switch (e.item.status) {
                        case 0:
                            this.countRoutines.created++;
                            break;
                        case 1:
                            this.countRoutines.assigned++;
                            break;
                        case 2:
                            this.countRoutines.working++;
                            break;
                        case 3:
                            this.countRoutines.done++;
                            break;
                        default:
                            this.countRoutines.unknow++;
                            break;
                    }
                });
                this.countRoutinesKey++;
                this.$bus.$emit('routinesData', routinesList);
            })
            .catch(e => {
                console.error('Error Getting Assigned Routines', e)
            })
        },
        getUserCompetitions (key) {
            axios.get(`${config.apiUrl}/competition/${key}`)
            .then(r => {
                this.userCompetitions = r.data.data;
                console.log('✅ User Competitions data', r.data.data);

                axios.get(`${config.apiUrl}/competitions/all`)
                .then(d => {
                    this.competitions = d.data.data;
                    let competitionsData = [];
                    this.userCompetitions.forEach(u => {
                        d.data.data.filter(x => {
                            if(u.item.competition_id == x.key){
                                console.log('✅✅ Competicion encontrada');
                                competitionsData.push({
                                    ...u.item,
                                    competition_info: x.item
                                });
                            }
                        });
                    })
                    console.log('✅ All competitions data', competitionsData);
                    this.currentUserCompetitions = competitionsData;
                    this.$bus.$emit('competitionData', competitionsData);
                })
                .catch(e => {
                    console.error('Error trainings', e);
                })
            })
            .catch(e => {
                console.error('Error Getting User Competitions', e);
            })
        },
        getTests (key) {
            axios.get('https://us-central1-atpro-app.cloudfunctions.net/api/tests/'+key)
            .then(r => {
                this.tests = r.data.data;
                this.testKey++;
                console.log('✅ Tests data', r.data.data);
                this.$bus.$emit('testsData', r.data.data);
            })
            .catch(e => {
                console.error('Error Getting Tests', e);
            })
        },
        getTrainingsTypes (key) {
            axios.get('https://us-central1-atpro-app.cloudfunctions.net/api/trainings')
            .then(r => {
                r.data.data.forEach(e => {
                    if(e.item.type === 'pre-workout'){
                        this.training_types.push({"id": e.item.id, "label": e.item.name})
                    }
                });
                this.training_types_array = r.data.data;
                console.log('✅ Trainings Types data', this.training_types);
            })
            .catch(e => {
                console.error('Error Getting training types', e);
            })
        },
        getTrainings (client_id) {
            axios.get(`https://us-central1-atpro-app.cloudfunctions.net/api/trainings/${client_id}`)
            .then(r => {
                this.trainings = r.data.data.map(e => e.item);
                // console.log('✅ Trainings data', client_id, this.trainings);
                this.getChargeByYearAndMonths(this.trainings);
            })
            .catch(e => {
                console.error('Error Getting trainings', e);
            })
        },
        getTrainingsStatistic (client_id) {
            axios.get(`https://us-central1-atpro-app.cloudfunctions.net/api/trainings_statistic/${client_id}`)
            .then(r => {
                this.trainings_statistic = r.data.data.map(e => e.item);
                // console.log('✅ Trainings Statistic data', client_id, this.trainings_statistic);
                this.filterStadisticsByYearAndMonths();
            })
            .catch(e => {
                console.error('Error Getting trainings statistic', e);
            })
        },
        generateReport(){
            // console.log('Report', this.report_type, this.prepost_type, this.training_type);
            if(this.prepost_type === 'post-entrenamiento' && this.report_type != null){
                this.generatePostWorkReport(this.trainings_statistic);  
                
            }else if(this.prepost_type === 'pre-entrenamiento' && this.report_type != null && this.training_type != null){
                this.generatePreWorkReport();
            }else{
                return console.log('❌ Please select all fields before generate a report');
            }
        },
        generatePostWorkReport(trainingList){
            // console.log('✅ Generating Post Work Report...');
            // console.log('Array Training Types', this.training_type);
                this.promedio = null;
                this.series = [];
                this.isHasGeneratedReport = true; 
                let arrayTempSeries = [];
                let arrayTempOptionPost = [];
                // let dataFilterByTrainingType = this.trainings_statistic.filter(r => r.training_type === 'post-entrenamiento');

                let postData = _.groupBy(trainingList, 'name');

                Object.keys(postData).forEach(e => {
                    let dArray = {
                        type: 'line',
                        name: e,
                        data: []
                    };
                    let xArray = [];
                    postData[e].forEach(p => {
                        dArray.data.push(parseInt(p.result))
                        xArray.push(moment(new Date((p.created_at._seconds) * 1000), "YYYY-MM-DD").format("YYYY-MM-DD"));
                    })
                    arrayTempSeries.push(dArray);
                    arrayTempOptionPost.push({
                        stroke: {
                            curve: 'smooth',
                            width: 2
                        },
                        xaxis: {
                            categories: xArray
                        }
                    });
                })

                this.series = arrayTempSeries;
                this.optionsPost = arrayTempOptionPost

                // console.log(postData);
                // this.$refs['post-entrenamiento'].show();
                this.pre_workout_report = false;
                this.post_workout_report = true;
        },
        generatePreWorkReport(){
                // console.log('✅ Generating Pre Work Report...', this.training_type);
            // console.log("Trainings", this.trainings);
            let prom = 0;
            this.isHasGeneratedReport = true; 
            if(this.report_type === 'Único'){
                this.series = [];
                let dataFilterByTrainingTypeId = this.trainings.filter(r => r.training_type_id === this.training_type.id);
                let dataFilterByTrainingType = dataFilterByTrainingTypeId.filter(r => r.training_type === 'pre-workout');

                if(dataFilterByTrainingType.length === 0){
                    return alert('No hay datos para generar el reporte');
                }
                let dArray = {
                    type: 'line',
                    name: this.training_type.label,
                    data: []
                };
                dataFilterByTrainingType.forEach(e => {
                    this.options.xaxis.categories.push(moment(new Date((e.activity_date._seconds) * 1000), "YYYY-MM-DD").format("YYYY-MM-DD"))
                    dArray.data.push(e.number_result);
                    prom+= e.number_result;
                })
                this.series.push(dArray);
                this.promedio = prom / dataFilterByTrainingType.length;
                // console.log('✅ Report data', dataFilterByTrainingType);
                // this.$refs['pre-entrenamiento'].show();
                this.pre_workout_report = true;
                this.post_workout_report = false;
            }else{
                this.promedio = null;
                this.series = [];
                this.training_type.forEach((t,i) => {
                    console.log(t, i);
                    let dataFilterByTrainingTypeId = this.trainings.filter(r => r.training_type_id === t.id);
                    let dataFilterByTrainingType = dataFilterByTrainingTypeId.filter(r => r.training_type === 'pre-workout');

                    if(dataFilterByTrainingType.length === 0){
                        return alert(`No hay datos para generar el reporte por ${t.label}`);
                    }
                    let dArray = {
                        type: 'line',
                        name: t.label,
                        data: []
                    };
                    dataFilterByTrainingType.forEach(e => {
                        dArray.data.push(e.number_result);
                    })
                    // this.series.push(dArray);
                    // console.log('✅ Report data', dataFilterByTrainingType);
                })
                this.pre_workout_report = true;
                this.post_workout_report = false;
                // this.$refs['pre-entrenamiento'].show();
            }
        },
        convertRoutineCodeToStatus(status) {
            switch (status) {
                case 0:
                    return "Creada"
                case 1:
                    return "Asignada"
                case 2:
                    return "En ejecución"
                case 3:
                    return "Terminada"
                default:
                    return "Desconocido"
            }
        },
        getWeightProgress() {
            const client_id = this.$route.params.id;
            axios.get(`${config.apiUrl}/weightProgress/${client_id}`)
            .then(r => {
                let seriesData = []
                r.data.data.map(e => {
                    seriesData.push(e.weight);
                    this.weightOptions.xaxis.categories.push(moment(new Date((e.created_at._seconds) * 1000), "YYYY-MM-DD").format("YYYY-MM-DD"))
                })
                this.weightSeries.push({
                    name: "Peso",
                    data: seriesData
                })
                this.weightKey++;
                this.loadingWeight = false;
                // console.log('✅ Weight Progress', r.data.data);
            })
            .catch(e => {
                console.error('Error Getting Single User info', e)
            })
        },

        selectTab(numberTab) {
            switch(numberTab){
                case 1:
                    this.itemOptionsSelected = 1;
                    this.year = true;
                    this.semester = false;
                    this.month = false;
                    break;
                case 2: 
                    this.itemOptionsSelected = 2;
                    this.year = false;
                    this.semester = true;
                    this.month = false;
                    break;
                case 3: 
                    this.itemOptionsSelected = 3;
                    this.year = false;
                    this.semester = false;
                    this.month = true;
                    break;
            }
        },

        filterStadisticsByYearAndMonths(){
            let stadistic_data = [];
            // converter dates
            this.trainings_statistic.forEach((e)=> {
                e.year = moment(new Date((e.created_at._seconds) * 1000), 'DD/MM/YYYY').year();
                e.month = moment(new Date((e.created_at._seconds) * 1000), 'DD/MM/YYYY').month() + 1;
                e.semester = e.month <= 6 ? 1 : 2;
                stadistic_data.push(e);
            });

            // filter years
            let yearFiltered = _.uniqBy(stadistic_data, 'year');
            this.yearList = yearFiltered.map((e)=>{
                return e.year;
            });

            // filter months
            let monthsFiltered = _.uniqBy(stadistic_data, 'month');
            this.monthList = monthsFiltered.map((e)=>{
                return e.month;
            }).sort((a, b) => {
                return a - b;
            });
           
            this.monthList = this.monthList.map((item)=>{
                return this.capitalize(this.toMonthName(item));
            });
        },
         
        // function for convert and filter year and month in each data
        getChargeByYearAndMonths(trainingsList){
            // converter dates
            trainingsList.forEach((e)=> {
                e.year = moment(new Date((e.created_at._seconds) * 1000), 'DD/MM/YYYY').year();
                e.month = moment(new Date((e.created_at._seconds) * 1000), 'DD/MM/YYYY').month() + 1;
                e.semester = e.month <= 6 ? 1 : 2;
            });
            // console.log("trainingsList", trainingsList)
            this.generateChartByCharge(trainingsList);
        },

        generateChartByCharge(trainingData){
            let arrayTempData = [];
            let arrayTempDate = [];
             //  chart generator
            trainingData.forEach(t => {
                    if(t.training_type === POST_WORKOUT && t.user_type === "client"){
                        // console.log("imprimiendo cargas", t.year);
                        this.loadTraining.push({
                            date: t.activity_date,
                            load: t.number_result * t.duration
                        })
                        // array load data
                        arrayTempData.push(t.number_result * t.duration)
                        // array created date
                        arrayTempDate.push(moment(new Date((t.activity_date._seconds) * 1000), "YYYY-MM-DD").format("YYYY-MM-DD"));
                    }
                });
                // overwrite data in the main array
                this.loadSeries[0].data = arrayTempData;
                this.loadOptions.xaxis.categories = arrayTempDate;
                this.countChargesKey++;
        },

        refreshData(refreshType){
            switch(refreshType){
                // filter by year
                case 1:
                    this.filterByYear();
                    break;
                // filter by year and semester
                case 2: 
                   this.filterBySemester();
                    break;
                // filter by year and month
                case 3: 
                    this.filterByMonth();
                    break;
            }
        },

        filterByYear(){
            // filter by year selected for training stadistic
            let yearsFilteredTrainingStadistic = this.trainings_statistic.filter((e)=> e.year === this.yearSelected);
            // filter by year card of charge
            let yearsFilteredTraining = this.trainings.filter((e)=> e.year === this.yearSelected);
            // call function to refresh charts
            this.generatePostWorkReport(yearsFilteredTrainingStadistic);
            // call function to refresh chart charge
            this.generateChartByCharge(yearsFilteredTraining)
        },

        filterBySemester(){
            // filtered training stadistic by semester
            let semesterFilteredTrainingStadistic = this.trainings_statistic.filter((e)=> e.year === this.yearSelected && e.semester === this.semesterSelected);
            // filter by semester card of charge
            let semesterFilteredTraining = this.trainings.filter((e)=> e.year === this.yearSelected && e.semester === this.semesterSelected);
            // call function to refresh charts
            this.generatePostWorkReport(semesterFilteredTrainingStadistic);
            // call function to refresh chart charge
            this.generateChartByCharge(semesterFilteredTraining);
        },

        filterByMonth(){
            // filtered training stadistic by semester
            let monthFilteredTrainingStadistic = this.trainings_statistic.filter((e)=> e.year === this.yearSelected && this.capitalize(this.toMonthName(e.month)) === this.monthSelected);
            // filter by semester card of charge
            let monthFilteredTraining = this.trainings.filter((e)=> e.year === this.yearSelected && this.capitalize(this.toMonthName(e.month)) === this.monthSelected);
            // call function to refresh charts
            this.generatePostWorkReport(monthFilteredTrainingStadistic);
            // call function to refresh chart charge
            this.generateChartByCharge(monthFilteredTraining);
        },

        toMonthName(monthNumber) {
            const date = new Date();
            date.setMonth(monthNumber - 1);

            return date.toLocaleString('es-CO', {
                month: 'long',
            });
        },

        capitalize(word) {
            return word[0].toUpperCase() + word.slice(1).toLowerCase();
        },

    },

    created () {
        // console.log(this.$route.params)
        if(this.$route.params.id){
            this.getUserData(this.$route.params.id);
            this.getRoutines(this.$route.params.id);
            this.getUserCompetitions(this.$route.params.id);
            this.getTests(this.$route.params.id);
            // this.getCompetitions();
            this.getTrainings(this.$route.params.id);
            this.getTrainingsStatistic(this.$route.params.id);
            this.getTrainingsTypes();
            this.getWeightProgress();
        }else{
            alert('ERROR EMPTY PROFILE ID!');
        }
    },
    mounted () {
        core.index();
        // this.mapRoutines();
        // console.log('CONFIG', config)
        // this.renderChart(this.chartdata, this.options)
    },
}
</script>

<style scoped>
.mt-60{
    margin-top: 60px;
}
.pre-entrenamiento-promedio{
    background: #f1f1f1;
    border-radius: 3px;
    padding: 0 10px;
    margin-bottom: 20px;
}
.pre-entrenamiento-promedio p{
    margin: 0;
    font-size: 16px;
}
.pre-entrenamiento-promedio p span{
    font-weight: bold;
    font-size: 20px;
}
.pre-entrenamiento, .post-entrenamiento{
    padding: 20px;
}

.btn-outline-primary.active {
    color: #ffffff;
    background-color: #1e88e5;
    border-color: #1e88e5;
}
</style>